<template>
  <CCol col="12" xl="12" class="p-0">
    <CCard class="p-0">
      <CCardHeader
        class="d-flex justify-content-between align-items-center bg-secondary"
      >
        <h5 class="text-light m-0 p-0">ویرایش رمزعبور</h5>
      </CCardHeader>

      <CAlert :show.sync="dismissCountDown" closeButton color="warning" fade>
        <strong class="rounded-circle mx-2 text-info">{{
          dismissCountDown
        }}</strong>
        {{ alertText }}
      </CAlert>

      <CForm class="needs-validation p-2" novalidate>
        <CRow>
          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="رمزعبور فعلی"
            required
            type="password"
            v-model="info.oldPassword"
            :value="info.oldPassword"
          />
        </CRow>

        <CRow>
          <CInput
            class="col-sm-12 col-md-4 col-lg-4"
            label="رمزعبور جدید"
            type="password"
            required
            v-model="info.newPassword"
            :value="info.newPassword"
          />
          <CInput
            class="col-sm-12 col-md-4 col-lg-4"
            label="تکرار رمزعبور جدید"
            type="password"
            required
            v-model="info.rePassword"
            :value="info.rePassword"
          />
        </CRow>

        <CRow class="justify-content-center mt-3">
          <CButton
            @click="changePassword()"
            class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2 btn-primary"
            ><CIcon name="cil-check-circle" />تایید</CButton
          >
          <CButton
            class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2 btn-danger"
            @click="clear()"
            ><CIcon name="cil-check-circle" />پاک کردن</CButton
          >
        </CRow>
      </CForm>
    </CCard>

     <!-- Alert modal -->
    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle != 'حذف ساختار سازمانی'"
          @click="alertModal = false"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
        <CButton
          v-if="alertModalTitle == 'حذف ساختار سازمانی'"
          @click="deleteOrganizationalStructure"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
      </template>
    </CModal>
  </CCol>
</template>

<script>
import axios from "axios";
import { Values } from "../../../src/commonValues";
export default {
  data() {
    return {
      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",
      info: {
        oldPassword: "",
        newPassword: "",
        rePassword: "",
      },

      userName: localStorage.getItem("username"), //read from local storage

      dismissCountDown: 0,
      alertText: "",
    };
  },

  methods: {
    changePassword() {
      var forms = document.querySelectorAll(".needs-validation");
      let formValid = true;

      for (var i = 0; i < forms[0].length; i++) {
        if (
          forms[0][i].type == "password" &&
          forms[0][i].required &&
          forms[0][i].value.length == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "number" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "textarea" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        }
      }
      if (formValid == true) {
        if (this.info.newPassword == this.info.rePassword) {
          axios
            .post(Values.serverIp + "User/ChangeUserPassword", {
              userName: this.userName,
              oldPassword: this.info.oldPassword,
              newPassword: this.info.newPassword,
            })
            .then((response) => {
              //console.log(response.data);
              if (response.status == 200 && response.data == "0") {
                
                // modal successfuly
                this.alertModal = true;
                this.alertModalTitle = "تغییرات";
                this.alertModalText = "تغییرات با موفقیت انجام شد.";
                this.alertModalColor = "success";
                this.alertModalButtonText = "تایید";
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                if (response.data == "1") {
                  this.alertModalText =
                    "رمز عبور فعلی اشتباه می باشد.";
                } else  {
                  this.alertModalText =
                    "لطفا دوباره تلاش نمایید.";
                }
                this.alertModalColor = "warning";
                this.alertModalButtonText = "تایید";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.dismissCountDown = 8;
          this.alertText = "رمزعبور جدید وارد شده و تکرار آن هم خوانی ندارد.";
        }
      } else {
        this.dismissCountDown = 8;
        this.alertText = "لطفا تمامی موارد را تکمیل نمایید.";
      }
    },

    clear() {
      this.info.oldPassword = "";
      this.info.newPassword = "";
      this.info.rePassword = "";
    },
  },
};
</script>

<style>
</style>